<template>
  <div>
    <div v-if="this.loadingFormSubmit == true" class="loader">Loading...</div>

    <div v-if="this.loadingFormSubmit == false" class="form-container">
      <el-card class="form-card">
        <h2>Create An Account</h2>
        <el-form ref="registrationForm">
          <el-form-item>
            <el-input
              type="email"
              placeholder="Email"
              prefix-icon="fas fa-at"
              v-model="form.email"
              :class="{error: $v.form.email.$error}"
            ></el-input>
            <p
              v-if="$v.form.email.$error"
              :class="{errormessage: $v.form.email.$error}"
            > This does not seem to be a valid email</p>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="Password"
              prefix-icon="fas fa-lock"
              :show-password="true"
              v-model="form.password"
              :class="{error: $v.form.password.$error}"
            ></el-input>
            <p
              v-if="$v.form.password.$error"
              :class="{errormessage: $v.form.password.$error}"
            >Passwords must match and cant be blank</p>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="Repeat Password"
              prefix-icon="fas fa-lock"
              :show-password="true"
              v-model="form.confirmpassword"
              :class="{error: $v.form.confirmpassword.$error}"
            ></el-input>
            <p
              v-if="$v.form.confirmpassword.$error"
              :class="{errormessage: $v.form.confirmpassword.$error}"
            >Passwords must match and cant be blank</p>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="First Name"
              prefix-icon="fas fa-user"
              v-model="$v.form.firstname.$model"
              :class="{error: $v.form.firstname.$error}"
            ></el-input>
            <p
              v-if="$v.form.firstname.$error"
              :class="{errormessage: $v.form.firstname.$error}"
            >This field is required</p>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="Last Name"
              prefix-icon="fas fa-user"
              v-model="$v.form.lastname.$model"
              :class="{error: $v.form.lastname.$error}"
            ></el-input>
            <p
              v-if="$v.form.lastname.$error"
              :class="{errormessage: $v.form.lastname.$error}"
            >This field is required</p>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="Phone Number"
              native-type="tel"
              prefix-icon="fas fa-mobile"
              v-model="$v.form.phonenumber.$model"
              :class="{error: $v.form.phonenumber.$error}"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <input type="checkbox"             
            v-model="$v.form.agreed.$model"
            :class="{error: $v.form.agreed.$error}"
            /> 
            <p id="terms-conditions"> I accept and agree to the <a href="https://jobase.io/terms/">  Terms </a> </p>
            <p id="privacy"> & <a href="https://jobase.io/privacy/"> privacy policy </a> </p>
          <p
              v-if="$v.form.agreed.$error"
              :class="{errormessage: $v.form.agreed.$error}"
            >Please accept the terms and privacy policy</p>
          </el-form-item>

          <el-form-item class="self-align">
            <el-button type="primary" @click.native="SubmitForm()" block>Register</el-button>
          </el-form-item>
          <br />
          <br />Already have an account?
          <router-link to="/Login">Login</router-link>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
import { required, email, sameAs } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      form: {
        email: "",
        password: "",
        confirmpassword: "",

        firstname: "",
        lastname: "",
        phonenumber: "",
        agreed: false
      },
      test: false,
      inputRules: [v => (v && v.length != 0) || "This field is required"],
      loadingFormSubmit: false
    };
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: {
        required,
        sameAsPassword: sameAs("confirmpassword")
      },
      confirmpassword: {
        required,
        sameAsPassword: sameAs("password")
      },

      firstname: {
        required
      },
      lastname: {
        required
      },
      phonenumber: {},
      agreed: {
        checked: value => value === true
      },
    }
  },
  methods: {
    SubmitForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {

        this.loadingFormSubmit = true;

        console.log("form is valid and submitted successfully", this.form);
        EventService.Register(this.form)
          .then(response => {
            if (response.status == 200) {
              this.$router.push({ name: "Registered" });
            }
          })
          .catch(error => {

            this.loadingFormSubmit = false;

            console.log(error);
          });
      }
    }
  }
};
</script>

<style scoped>
.error {
  border: 1px solid black;

  outline-color: red;
  outline-width: thin;
}

.errormessage {
  color: red;
}
#terms-conditions{
  display: inline-block;
  margin: 0px 0px 0px 5px;
    }
#privacy{
  margin: 0px 0px 0px 24px;
}
</style>
